<template>
  <VincCalculatingDetail />
</template>

<script>
import VincCalculatingDetail from "@/components/Calculatings/VincCalculating/Detail.vue";
export default {
  components: { VincCalculatingDetail },
};
</script>

<style></style>
